import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "p-py-3" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_skeleton_text = _resolveComponent("skeleton-text")!
  const _component_skeleton_icon = _resolveComponent("skeleton-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_skeleton_text, {
      sm: "",
      length: 20
    }),
    _createVNode(_component_skeleton_text, {
      maxWords: 3,
      class: "p-py-2"
    }),
    _createVNode(_component_skeleton_text, {
      sm: "",
      maxWords: 3
    }),
    _hoisted_1,
    _createVNode(_component_skeleton_text, {
      maxWords: 4,
      class: "p-pb-3"
    }),
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
      return _createElementVNode("div", {
        class: "p-d-flex p-pl-3 p-pr-1 p-py-2",
        key: i
      }, [
        _createVNode(_component_skeleton_icon, { class: "p-mr-3" }),
        _createVNode(_component_skeleton_text, {
          maxWords: Math.floor(Math.random() * 6) + 4,
          sm: ""
        }, null, 8, ["maxWords"])
      ])
    }), 64))
  ], 64))
}